import { consignee, consigneeUser } from "@/utils/constants";
import { handleResponse, handleError } from "@/utils/functions";

export default (axios) => ({
  getConsigneeList(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(consigneeUser.base, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getConsigneeDetails(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${consignee.base}${id}/view/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getConsigneeOrderList(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(consignee.order, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getConsigneeItemsList(payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${consignee.order}${payload.id}/items/`, {
          params: payload.params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getConsigneeOrderLogs(payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${consignee.order}${payload.id}/logs/`, {
          params: payload.params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getConsigneeOrderDetails(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${consignee.order}${id}/view/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getConsigneeTripList(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(consignee.trip, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getConsigneeTripDetails(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${consignee.trip}${id}/view/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getConsigneeObject(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${consigneeUser.base}${id}/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  createConsigneeObject(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${consigneeUser.base}`, data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  updateConsigneeObject(payload) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${consigneeUser.base}${payload.id}/`, payload.data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  partiallyUpdateConsigneeObject(payload) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${consigneeUser.base}${payload.id}/`, payload.data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getConsigneeSelectList(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(consignee.select, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getConsigneeOrderAttachment(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${consignee.base}order/${id}/generate_e_pod/`, {
          headers: { "Content-type": "application/pdf" },
        })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
});
